import { render, staticRenderFns } from "./info-documents-item.vue?vue&type=template&id=7910dfb8&scoped=true&"
import script from "./info-documents-item.vue?vue&type=script&lang=js&"
export * from "./info-documents-item.vue?vue&type=script&lang=js&"
import style0 from "./info-documents-item.vue?vue&type=style&index=0&id=7910dfb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910dfb8",
  null
  
)

export default component.exports